import React from 'react';
import Icon from '../../../components/AppIcon';

const UserJourneyFunnel = ({ data, selectedSegment }) => {
  const maxValue = Math.max(...data?.map(stage => stage?.users));

  const getConversionRate = (current, previous) => {
    if (!previous) return 100;
    return ((current / previous) * 100)?.toFixed(1);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">User Journey Funnel</h3>
        <div className="flex items-center gap-2 text-sm text-muted-foreground caption">
          <Icon name="Users" size={16} />
          <span>Segment: {selectedSegment}</span>
        </div>
      </div>
      <div className="space-y-3">
        {data?.map((stage, index) => {
          const widthPercentage = (stage?.users / maxValue) * 100;
          const conversionRate = getConversionRate(
            stage?.users,
            index > 0 ? data?.[index - 1]?.users : null
          );
          const dropoffRate = index > 0 ? (100 - parseFloat(conversionRate))?.toFixed(1) : 0;

          return (
            <div key={stage?.stage} className="space-y-2">
              <div className="flex items-center justify-between text-sm">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                    <Icon name={stage?.icon} size={16} className="text-primary" />
                  </div>
                  <span className="font-medium text-foreground">{stage?.stage}</span>
                </div>
                <div className="flex items-center gap-4">
                  <span className="font-data text-foreground font-semibold">
                    {stage?.users?.toLocaleString()}
                  </span>
                  <span className="text-success caption">{conversionRate}%</span>
                </div>
              </div>
              <div className="relative">
                <div className="h-12 bg-muted/30 rounded-lg overflow-hidden">
                  <div
                    className="h-full bg-gradient-to-r from-primary to-secondary transition-all duration-500 flex items-center justify-between px-4"
                    style={{ width: `${widthPercentage}%` }}
                  >
                    <span className="text-xs font-medium text-primary-foreground">
                      {stage?.avgTime}
                    </span>
                    {index > 0 && dropoffRate > 0 && (
                      <span className="text-xs font-medium text-primary-foreground/80">
                        -{dropoffRate}% drop
                      </span>
                    )}
                  </div>
                </div>
              </div>
              {index < data?.length - 1 && (
                <div className="flex items-center justify-center py-2">
                  <Icon name="ChevronDown" size={20} className="text-muted-foreground" />
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div className="mt-6 p-4 bg-muted/20 rounded-lg">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <div className="text-xs text-muted-foreground caption mb-1">Overall Conversion</div>
            <div className="text-xl font-bold text-foreground font-data">
              {getConversionRate(data?.[data?.length - 1]?.users, data?.[0]?.users)}%
            </div>
          </div>
          <div>
            <div className="text-xs text-muted-foreground caption mb-1">Avg. Journey Time</div>
            <div className="text-xl font-bold text-foreground font-data">4.2 days</div>
          </div>
          <div>
            <div className="text-xs text-muted-foreground caption mb-1">Biggest Drop-off</div>
            <div className="text-xl font-bold text-error font-data">Trial → Pro (42%)</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserJourneyFunnel;